/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import CustomButton from "@/ui/Buttons/CustomButton";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import useNotiStack from "@/hooks/useNotistack";

import { useChangePasswordAdmin } from "@/hooks/useUser";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { error, regexFormat } from "../regexFormate/regexFormate";

//=== TYPES ====
interface IPassword {
  handleClose: any;
}

interface updateprofileInput {
  old_password: string;
  new_password: string;
  confirm_password: string;
}

// schema

const schema = yup
  .object()
  .shape({
    new_password: yup
      .string()
      .trim()
      .required(" New Password  is required!")
      //.matches(regexFormat.password, error.passwordFormat)
      .min(6, "Password must be at least 6 characters"),

    confirm_password: yup
      .string()
      .trim()
      .required("Confirm Password is required")
      .oneOf(
        [yup.ref("new_password")],
        "New password and confirm password should match"
      ),
  })
  .required();

export default function ChangePassword({ handleClose }: IPassword) {
  const {
    handleSubmit,
    control,
    register,
    reset,
    watch,
    setValue,

    formState: { errors },
  } = useForm<updateprofileInput>({
    resolver: yupResolver(schema),
  });

  const [showPass, setShowPass] = React.useState(false);
  const [showPass1, setShowPass1] = React.useState(false);
  const { mutate: changePasswordAdmin, isLoading } = useChangePasswordAdmin();
  const handelchange = (data: updateprofileInput) => {
    handleClose();
    changePasswordAdmin(data);
  };

  return (
    <Box className="serviceModal">
      <Box className="serviceModalTxt">
        <h4>Change Password</h4>

        <Box className="inputWrapper change_password">
          <label> New Password</label>
          <input
            type={showPass ? "text" : "password"}
            placeholder="Enter New Password"
            {...register("new_password")}
          />

          <span className="open_eyes" onClick={() => setShowPass(!showPass)}>
            {showPass ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </span>
          {errors.new_password && (
            <p
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              {errors.new_password.message}
            </p>
          )}
        </Box>

        <Box className="inputWrapper change_password">
          <label> Confirm Password</label>
          <input
            type={showPass1 ? "text" : "password"}
            placeholder="Enter Confirm Password"
            {...register("confirm_password")}
          />
          <span className="open_eyes" onClick={() => setShowPass1(!showPass1)}>
            {showPass1 ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </span>
          {errors.confirm_password && (
            <p
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              {errors.confirm_password.message}
            </p>
          )}
        </Box>
        <button
          style={{
            position: "absolute",
            top: "6px",
            right: "11px",
            border: "0px",
            background: "transparent",
            cursor: "pointer",
          }}
          type="button"
          onClick={handleClose}
        >
          <span>
            <CloseIcon />
          </span>
        </button>

        <Box className="buttonGroup">
          <CustomButton
            type="button"
            onClick={handleSubmit(handelchange)}
            loading={isLoading}
          >
            <p>Change Password</p>
          </CustomButton>
        </Box>
      </Box>

      {/* <ManageAdminTable allAdminLists={allAdminLists} /> */}
    </Box>
  );
}
